import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../shared/entities/user';
import { Router } from '@angular/router';

@Component({
  selector: 'app-agreement',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './agreement.component.html',
  styleUrl: './agreement.component.scss'
})
export class AgreementComponent implements OnInit {
  accept: boolean = false;
  user: User = {};

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router) {}

  ngOnInit(): void {
    this.user = this.authService.loggedInUser();
  }

  registerUser() {
    this.userService.registerNewUser()
    .subscribe(profile => {
          this.toastr.success(`Terms and conditions agreement registered successfully`);
          this.router.navigate(['/']);
        });
  }
}
